import { Attributes, Children, Component } from 'react';
import styles from './sortable.component.module.scss';


interface SortableItemComponentProps extends Attributes {
    onTouchStart: (e) => void;
    onMouseDown: (e) => void;
    children?: any;
    index: number;
    uniquekey: string;
}

export default class SortableItemComponent extends Component<SortableItemComponentProps> {

    shouldComponentUpdate() {
        return true;
    }

    emitMouseDown(e) {
        if (e.button === 0) {
            // Emit mouse event on left button click only
            this.props.onMouseDown(e)
        }
    }

    render() {
        // console.log(`Image at ${this.props.index} ${this.props.uniquekey} is ${this.props.children.props.children.props.uploadInProgressFile.file.name}`);
        return (
            <div
                key={`${this.props.uniquekey}`}
                className={`b${this.props.index} sortable-item ${styles["sortable-item"]} col-12 mb-2 g-0`}
                onMouseDown={e => this.emitMouseDown(e)}
                onTouchStart={e => this.props.onTouchStart(e)}
            >
                <div className={`d-flex align-items-center sort-handler ${styles['sort-handler']}`}>
                    <img width={"16px"} height={"16px"}
                        className={` ${styles['drag-handler-icon']}`}
                        src="/icons/svg/drag-handler.svg"
                        alt='Start'
                    />
                </div>
                <div className='flex-grow-1'>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
